// featured collection swiper slider
 document.addEventListener('DOMContentLoaded', function() {
  var featuredswiper;

  function featuredinitSwiper() {
     $('.swiper-container.demo').each(function() {
        var enable = $(this).data("enable-slider"); 
        var desktop = $(this).data("desktop");
        var large_tablet = $(this).data("large-tablet");
        var tablet = $(this).data("tablet");
        var mobile = $(this).data("mobile");
        var autoplay = $(this).data("autoplay");
        var loop = $(this).data("loop");
        var speed = $(this).data("speed");

      if(enable){
        featuredswiper = new Swiper('.swiper-container.demo', {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          autoplay: autoplay,
          loop: loop,
          speed: speed,
          dots:true,
           navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            320: {
              slidesPerView: mobile,
              spaceBetween: 15
            },
            480: {
              slidesPerView: tablet
            },
            641: {
              slidesPerView: large_tablet
            },
            768: {
              slidesPerView: large_tablet
            },
            992: {
              slidesPerView: desktop
            },
          },
        });
       }
    });
  }

  // Initialize Featured Swiper on page load
  featuredinitSwiper();

  document.addEventListener('shopify:section:select', function() {
    // Reinitialize Featured Swiper on section select
    featuredinitSwiper();
  });

  document.addEventListener('shopify:section:load', function() {
      // Reinitialize Featured swiper on section load
      featuredinitSwiper();
  });

  document.addEventListener('shopify:section:deselect', function() {
    // Cleanup Featured Swiper on section deselect if necessary
    if (featuredswiper) {
      featuredswiper.destroy();
      featuredswiper = null;
    }
  });
});

// shipping slider

document.addEventListener('DOMContentLoaded', function() {
  let shippingswiper;

  function initshippingswiper() {
    $('.Shipping-inner-row').each(function() {
      var desktop = $(this).data("desktop");
      var large_tablet = $(this).data("large-tablet");
      var tablet = $(this).data("tablet");
      var mobile = $(this).data("mobile");
      var autoplay = $(this).data("autoplay");
      
      shippingswiper = new Swiper('.Shipping-inner-row', {
        slidesPerView: desktop,
        spaceBetween: 30,
        autoplay: autoplay,
        grabCursor: true,
        freeMode: false,
        mousewheel: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: mobile
          },
          576: {
            slidesPerView: tablet
          },
          768: {
            slidesPerView: large_tablet
          },
          992: {
            slidesPerView: desktop
          }
        },
      });
    });
  }

  // Initialize shipping swiper on page load
  initshippingswiper();

  document.addEventListener('shopify:section:select', function() {
    // Reinitialize shipping swiper on section select
    initshippingswiper();
  });

  document.addEventListener('shopify:section:load', function() {
      // Reinitialize shipping swiper on section load
      initshippingswiper();
  });

  document.addEventListener('shopify:section:deselect', function() {
    // Cleanup shipping swiper on section deselect if necessary
    if (shippingswiper) {
      shippingswiper.destroy();
      shippingswiper = null;
    }
  });
});

// category collection swiper slider

document.addEventListener('DOMContentLoaded', function() {
  let categoryswiper;

  function initcategoryswiper() {
    $('.main-collection-list-wrapper').each(function() {
      var enable = $(this).data("enable");
      var desktop = $(this).data("desktop");
      var tablet = $(this).data("tablet");
      var mobile = $(this).data("mobile");
      var autoplay = $(this).data("autoplay");
      var loop = $(this).data("loop");
      var speed = $(this).data("speed");
      
      if(enable){
        categoryswiper = new Swiper('.main-collection-list-wrapper', {
          slidesPerView: 1,
          spaceBetween: 30,
          autoplay: autoplay,
          grabCursor: true,
          freeMode: false,
          speed: speed,
          loop: loop,
          mousewheel: false,
           navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: ".category-swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            320: {
              slidesPerView: mobile,
              spaceBetween: 15
            },
            480: {
              slidesPerView: tablet
            },
            576: {
              slidesPerView: tablet
            },
            768: {
              slidesPerView: tablet
            },
            992: {
              slidesPerView: desktop
            }
          },
        });
      }
    });
  }

  // Initialize category swiper on page load
  initcategoryswiper();

  document.addEventListener('shopify:section:select', function() {
    // Reinitialize category swiper on section select
    initcategoryswiper();
  });
  
  document.addEventListener('shopify:section:load', function() {
    // Reinitialize category swiper on section load
    initcategoryswiper();
  });

  document.addEventListener('shopify:section:deselect', function() {
    // Cleanup category swiper on section deselect if necessary
    if (categoryswiper) {
      categoryswiper.destroy();
      categoryswiper = null;
    }
  });
});

// testimonial slider

document.addEventListener('DOMContentLoaded', function() {
  let testi;

  function initTestimonialSwiper() {
    $('.testimonial-wrap').each(function() {
      var desktop = $(this).data("desktop");
      var tablet = $(this).data("tablet");
      var mobile = $(this).data("mobile");
      var autoplay = $(this).data("autoplay");
      var loop = $(this).data("loop");
      var speed = $(this).data("speed");
      var freemode = $(this).data("freemode");
      var mousewheel = $(this).data("mousewheel");
      
      testi = new Swiper('.testimonial-wrap', {
        spaceBetween: 30,
        freeMode: freemode,
        loop: loop,
        speed: speed,
        autoplay: autoplay,
        mousewheel: mousewheel,
        navigation: {
          nextEl: ".testi-swiper-button-next",
          prevEl: ".testi-swiper-button-prev"
        },
        pagination: {
          el: '.swiper-pagination',
             type: 'bullets',
          clickable:'true'
        },
        breakpoints: {
          320: {
            slidesPerView: mobile,
            spaceBetween: 15
          },
          480: {
            slidesPerView: mobile
          },
          576: {
            slidesPerView: mobile
          },
          768: {
            slidesPerView: tablet
          },
          992: {
            slidesPerView: desktop
          },
        }
      });
    });
  }

  // Initialize testimonial swiper on page load
  initTestimonialSwiper();

  document.addEventListener('shopify:section:select', function() {
    // Reinitialize testimonial swiper on section select
    initTestimonialSwiper();
  });

  document.addEventListener('shopify:section:deselect', function() {
    // Cleanup testimonial swiper on section deselect if necessary
    if (testi) {
      testi.destroy();
      testi = null;
    }
  });
});

// blog swiper slider

document.addEventListener('DOMContentLoaded', function() {
    let blog;
  
    function initBlogSwiper() {
      $('.swiper-slider-blog').each(function() {
        var desktop = $(this).data("desktop");
        var tablet = $(this).data("tablet");
        var mobile = $(this).data("mobile");
        var autoplay = $(this).data("autoplay");
        var loop = $(this).data("loop");
        var speed = $(this).data("speed");
        var freemode = $(this).data("freemode");
        var mousewheel = $(this).data("mousewheel");
        
        blog = new Swiper('.swiper-slider-blog', {
          slidesPerView: 1,
          grabCursor: true,
          freeMode: freemode,
          autoplay: autoplay,
          spaceBetween: 30,
          loop: loop,
          speed: speed,
          mousewheel: mousewheel,
          keyboard: {
            enabled: true
          },
          pagination: {
            el: ".blog-swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          breakpoints: {
             320: {
              slidesPerView: mobile,
              spaceBetween: 15
            },
            480: {
              slidesPerView: mobile
            },
            576: {
              slidesPerView: mobile
            },
            768: {
              slidesPerView: tablet
            },
            992: {
              slidesPerView: desktop
            },
          }
        });
      });
    }
  
    // Initialize blog swiper on page load
    initBlogSwiper();
  
    document.addEventListener('shopify:section:select', function() {
      // Reinitialize blog swiper on section select
      initBlogSwiper();
    });

    document.addEventListener('shopify:section:load', function() {
      // Reinitialize blog swiper on section load
      initBlogSwiper();
    });
  
    document.addEventListener('shopify:section:deselect', function() {
      // Cleanup blog swiper on section deselect if necessary
      if (blog) {
        blog.destroy();
        blog = null;
      }
    });
  });

// instagram swiper slider
document.addEventListener('DOMContentLoaded', function() {
    let instagramSwiper;
  
    function initInstagramSwiper() {
      $('.main-instagram-post-section-wrapper').each(function() {
        var desktop = $(this).data("desktop");
        var large_tablet = $(this).data("large-tablet");
        var tablet = $(this).data("tablet");
        var mobile = $(this).data("mobile");
        var autoplay = $(this).data("autoplay");
        var loop = $(this).data("loop");
        var speed = $(this).data("speed");
        
        instagramSwiper = new Swiper('.main-instagram-post-section-wrapper', {
          slidesPerView: 1,
          spaceBetween: 30,
          autoplay: autoplay,
          grabCursor: true,
          freeMode: false,
          loop: loop,
          speed: speed,
          mousewheel: false,
           navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: ".instagram-swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            320: {
              slidesPerView: mobile,
              spaceBetween: 15
            },
            480: {
              slidesPerView: tablet
            },
            641: {
              slidesPerView: large_tablet
            },
            768: {
              slidesPerView: large_tablet
            },
            992: {
              slidesPerView: desktop
            },
          },
        });
      });
    }
  
    // Initialize Instagram swiper on page load
    initInstagramSwiper();
  
    document.addEventListener('shopify:section:select', function() {
      // Reinitialize Instagram swiper on section select
      initInstagramSwiper();
    });

    document.addEventListener('shopify:section:load', function() {
      // Reinitialize Instagram swiper on section load
      initInstagramSwiper();
    });
  
    document.addEventListener('shopify:section:deselect', function() {
      // Cleanup Instagram swiper on section deselect if necessary
      if (instagramSwiper) {
        instagramSwiper.destroy();
        instagramSwiper = null;
      }
    });
  });

// brand swiper slider

document.addEventListener('DOMContentLoaded', function() {
    let brand;
  
    function initBrandSwiper() {
       $('.brand-slider-section-wrapper').each(function() {
        var desktop = $(this).data("desktop");
        var large_tablet = $(this).data("large-tablet");
        var tablet = $(this).data("tablet");
        var mobile = $(this).data("mobile");
        var autoplay = $(this).data("autoplay");
        var loop = $(this).data("loop");
        var speed = $(this).data("speed");
         
        brand = new Swiper('.brand-slider-section-wrapper', {
          slidesPerView: 1,
          spaceBetween: 140,
          autoplay: autoplay,
          grabCursor: true,
          freeMode: false,
          loop: loop,
          speed: speed,
          mousewheel: false,
           navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: ".brand-swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            320: {
              slidesPerView: mobile,
              spaceBetween: 30
            },
            575: {
              slidesPerView: tablet,
              spaceBetween: 60
            },
            767: {
              slidesPerView: tablet,
              spaceBetween: 80
            },
            990: {
              slidesPerView: large_tablet,
              spaceBetween: 100
            },
            1199: {
              slidesPerView: large_tablet,
              spaceBetween: 120
            },
            1429: {
              slidesPerView: desktop,
            },
          }
        });
      });
    }
  
    // Initialize brand swiper on page load
    initBrandSwiper();
  
    document.addEventListener('shopify:section:select', function() {
      // Reinitialize brand swiper on section select
      initBrandSwiper();
    });

    document.addEventListener('shopify:section:load', function() {
      // Reinitialize brand swiper on section load
      initBrandSwiper();
    });
  
    document.addEventListener('shopify:section:deselect', function() {
      // Cleanup brand swiper on section deselect if necessary
      if (brand) {
        brand.destroy();
        brand = null;
      }
    });
  });

// tab-product swiper slider
document.addEventListener('DOMContentLoaded', function() {
  var Tabswiper;

  function TabinitSwiper() {
    $('.swiper-container#lg-product-tab-slider').each(function() {
      var desktop = $(this).data("desktop");
      var large_tablet = $(this).data("large-tablet");
      var tablet = $(this).data("tablet");
      var mobile = $(this).data("mobile");
      var autoplay = $(this).data("autoplay");
      var loop = $(this).data("loop");
      var speed = $(this).data("speed");
      
      Tabswiper = new Swiper('.swiper-container#lg-product-tab-slider', {
        slidesPerView: desktop,
        spaceBetween: 30,
        observer: true,
        observeParents: true,
        dots:true,
        loop: loop,
        speed: speed,
        autoplay: autoplay,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          320: {
            slidesPerView: mobile,
            spaceBetween: 15
          },
          480: {
            slidesPerView: tablet
          },
          641: {
            slidesPerView: large_tablet
          },
          768: {
            slidesPerView: large_tablet
          },
          992: {
            slidesPerView: desktop
          },
        }
      });
    });
  }

  // Initialize Tab Swiper on page load
  TabinitSwiper();

  document.addEventListener('shopify:section:select', function() {
    // Reinitialize Tab Swiper on section select
    TabinitSwiper();
  });

  document.addEventListener('shopify:section:load', function() {
      // Reinitialize Tab swiper on section load
      TabinitSwiper();
  });

  document.addEventListener('shopify:section:deselect', function() {
    // Cleanup Tab Swiper on section deselect if necessary
    if (Tabswiper) {
      Tabswiper.destroy();
      Tabswiper = null;
    }
  });
});

// main-collection-grid slider
  document.addEventListener('DOMContentLoaded', function() {
    let collectionswiper;
  
    function initcategoryswiper() {
      $('.collection_slider').each(function() {
        var enable = $(this).data("enable");
        var desktop = $(this).data("desktop");
        var large_tablet = $(this).data("large-tablet");
        var tablet = $(this).data("tablet");
        var mobile = $(this).data("mobile");
        var autoplay = $(this).data("autoplay");
        var loop = $(this).data("loop");
        var speed = $(this).data("speed");

        if(enable){
          collectionswiper = new Swiper('.collection_slider', {
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: autoplay,
            loop: loop,
            speed: speed,
            freeMode: false,
            mousewheel: false,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
              320: {
                slidesPerView: mobile,
                spaceBetween: 15
              },
              480: {
                slidesPerView: tablet
              },
              681: {
                slidesPerView: large_tablet
              },
              768: {
                slidesPerView: large_tablet
              },
              992: {
                slidesPerView: desktop
              }
            },
          });
        }
      });
    }
  
    // Initialize category swiper on page load
    initcategoryswiper();
  
    document.addEventListener('shopify:section:select', function() {
      // Reinitialize category swiper on section select
      initcategoryswiper();
    });
  
    document.addEventListener('shopify:section:deselect', function() {
      // Cleanup category swiper on section deselect if necessary
      if (collectionswiper) {
        collectionswiper.destroy();
        collectionswiper = null;
      }
    });
  });